import { render, staticRenderFns } from "./SideFunctionBar_Compare.vue?vue&type=template&id=6b1da156"
import script from "./SideFunctionBar_Compare.vue?vue&type=script&lang=js"
export * from "./SideFunctionBar_Compare.vue?vue&type=script&lang=js"
import style0 from "./SideFunctionBar_Compare.vue?vue&type=style&index=0&id=6b1da156&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports